import { render, staticRenderFns } from "./CovidResources.vue?vue&type=template&id=ce138824&scoped=true&"
import script from "./CovidResources.vue?vue&type=script&lang=js&"
export * from "./CovidResources.vue?vue&type=script&lang=js&"
import style0 from "./CovidResources.vue?vue&type=style&index=0&id=ce138824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce138824",
  null
  
)

export default component.exports